/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submitted_ByInputs */



/**
* | output |
* | --- |
* | "Submitted By" |
*
* @param {Submitted_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submitted_by = /** @type {((inputs?: Submitted_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submitted_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soumis par")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingereicht von")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inviato da")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прислано")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviado por")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提交人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("提出者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("द्वारा प्रस्तुत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviado por")
	return /** @type {LocalizedString} */ ("Submitted By")
});